import talentsData from "../data/talents.json"
import { getEffective } from "./applyHomebrew"

const asArray = (v) => (Array.isArray(v) ? v : v ? [v] : [])

function getInnateTalents(character) {
  const talents = getEffective('talents', talentsData);
  const found = [];
  const add = (item, talent, count) => {
    const existing = found.find((f) => f.item === item && f.key === talent.Key);
    if (existing) { existing.count += count }
    else { found.push({ item, key: talent.Key, name: item.Name + ": " + talent.Name, data: talent, count }) }
  };

  const equipped = [...asArray(character.Weapons), ...asArray(character.Armor), ...asArray(character.Gear)]
    .filter((item) => item && (item.Equipped === true || item.Equipped === "true"));

  equipped.forEach((item) => {
    asArray(item.BaseMods).forEach((mod) => {
      if (!mod) { return }
      const byKey = mod.Key && talents.find((t) => t.Key === mod.Key);
      if (byKey) { add(item, byKey, Math.abs(parseInt(mod.Count)) || 1); return }
      const match = typeof mod.MiscDesc === "string" && mod.MiscDesc.match(/^Innate Talent: (.+)$/);
      const byName = match && talents.find((t) => t.Name === match[1]);
      if (byName) { add(item, byName, 1) }
    });
  });

  return found;
}

export default getInnateTalents
